import { TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import {
  DEVICE_NOT_REPORTED,
  CONTACT_SUPPORT,
  NON_POWERED_ASSET_DETECTED,
  HELP_CENTER,
  EVC_DETECTED,
  OEM_DETECTED,
  DUPLICATE_VEHICLE_ASSET_DETECTED,
  EVC_DETECTED_GOVT,
  OEM_DETECTED_GOVT,
} from "../../../constants/technicianAppointmentConstants";
import CPNotification from "../../../pages/Login/CPNotification";

const getErrorMessages = (error) => (
  <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px" margin="0">
    {error}
  </TextWrapperSpan>
);

const getSupportLink = (url, urlName, ariaLabel, pendoId) => (
  <TextWrapperSpan
    as="a"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    isLink
    aria-label={ariaLabel}
    fontSize="14px"
    fontWeight="400"
    lineHeight="20px"
    margin="0"
    textDecorationLine="underline"
    id={pendoId}
  >
    {urlName}
  </TextWrapperSpan>
);

const BLOCKING_ERROR_NOTIFICATIONS = {
  DEVICE_NOT_REPORTED: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(DEVICE_NOT_REPORTED)}{" "}
      {getSupportLink(
        "https://reveal-help.verizonconnect.com/hc/p/contact_support",
        CONTACT_SUPPORT,
        "contact support",
        "cfst-current-vin-no-device-faq"
      )}
    </CPNotification>
  ),
  NON_POWERED_ASSET_DETECTED: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(NON_POWERED_ASSET_DETECTED)}{" "}
      {getSupportLink(
        "https://install.verizonconnect.com/hc/articles/6485122359315",
        HELP_CENTER,
        "help center",
        "cfst-current-vin-non-powered-asset-help_center"
      )}
    </CPNotification>
  ),
  EVC_DETECTED: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(EVC_DETECTED)}
    </CPNotification>
  ),
  EVC_DETECTED_GOVT: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(EVC_DETECTED_GOVT)}
    </CPNotification>
  ),
  OEM_DETECTED: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(OEM_DETECTED)}
    </CPNotification>
  ),
  OEM_DETECTED_GOVT: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(OEM_DETECTED_GOVT)}
    </CPNotification>
  ),
  DUPLICATE_VEHICLE_ASSET_DETECTED: (
    <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0.5rem 0rem">
      {getErrorMessages(DUPLICATE_VEHICLE_ASSET_DETECTED)}
    </CPNotification>
  ),
};
export default BLOCKING_ERROR_NOTIFICATIONS;
